import { frontendURL } from '../../../helper/URLHelper';

const TasksView = () => import('./TasksView.vue');

// Mismos permisos que Pipelines: administradores y agentes. Qué tareas ve cada
// uno lo decide la API (CommercialTaskPolicy::Scope).
const TASK_PERMISSIONS = ['administrator', 'agent'];

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/tasks'),
      name: 'tasks_dashboard',
      component: TasksView,
      meta: {
        permissions: TASK_PERMISSIONS,
      },
    },
  ],
};
